import { useMemo } from 'react';
import { ColumnDef } from '@tanstack/react-table';
import { Hash, Logs } from 'lucide-react';
import { Link } from 'react-router-dom';
import PaginatedDataTable from '@/components/DataTable/PaginatedDataTable';
import { ICall } from '@/types';
import Section from '../Section';
import Time from '../Time';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';

const Scorecards = () => {
  const columns: ColumnDef<ICall>[] = useMemo(
    () => [
      {
        accessorKey: 'id',
        header: 'Call',
        cell: ({ row }) => {
          return (
            <>
              <Button variant={'outline'} className="py-1.5 rounded-full px-2 text-sm cursor-pointer" asChild>
                <Link to={`/call_scenarios/${row.original.id}`} className="flex items-center gap-1">
                  <Hash />
                  {row.original.id}
                </Link>
              </Button>
            </>
          );
        },
      },
      {
        accessorKey: 'scenario.name',
        header: 'Scenario',
        cell: ({ row }) => <>{row.original.scenario?.name}</>,
      },
      {
        accessorKey: 'user.name',
        header: 'Agent',
        cell: ({ row }) => <>{row.original.user?.name}</>,
      },

      {
        accessorKey: 'duration',
        header: 'Duration',
        cell: ({ row }) => <>{row.original.duration || 'N/A'}</>,
      },
      {
        accessorKey: 'created_at',
        header: 'Called',
        cell: ({ row }) => <Time>{row.original.created_at}</Time>,
      },
      {
        accessorKey: 'status',
        header: 'Status',
        cell: ({ row }) => <Badge>{row.original.status}</Badge>,
      },
    ],
    [],
  );

  return (
    <>
      <div className="flex items-center justify-between gap-2 mb-8">
        <div className="flex items-center gap-2 mb-4 ">
          <Logs />
          <div className="text-lg font-bold">Scenario Call History</div>
        </div>
      </div>

      <Section>
        <PaginatedDataTable url={'/v1/calls?call_type=scenario'} columns={columns} />
      </Section>
    </>
  );
};

export default Scorecards;
